
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { ApiServiceERP } from '../../../apis/ApiServiceERP';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';

export class listClient {

  id_client: number;
  id: number;
  name: string;
  
}


@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-frente-client.component.html',
  styleUrls: ['./edit-frente-client.component.scss']
})
export class EditFrenteClientComponent implements  AfterViewInit, OnDestroy, OnInit  {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  annex: any[] = []
  annexForm: FormGroup;
  step:number = 0
  title="Datos"
  createClient: listClient;
  items!: FormArray;
  paymentsform: FormGroup;
  createClientForm: FormGroup;
  idSubscription: Subscription;
  id:0;
  id_client:0;
  name:string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private apiService: ApiServiceERP,
    private errorService:ErrorService
  ) { 
    this.route.params.subscribe((params) => {
      this.id = params['id'];
      this.name = params['name'];
      this.id_client = params['id_client'];
    });
   
  }

  ngOnInit(): void {
    


    this.spinner.show();
    this.spinner.hide();
   
   

    this.createClientForm = this.fb.group({
      id_client: [''],
      id: [''],
      name: this.name,
      
    });

   



    
  }
  

 
 
    ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  rerender(): void {
    
    
  }



  formSubmit(): void {

    if(this.createClientForm.value.name == ""){
      Swal.fire({title:"Debe selecciona un nombre" ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    
    
    this.spinner.show();



    this.createClient = this.createClientForm.value;
    this.createClient.id_client = Number(this.id_client);
    this.createClient.id = Number(this.id);
    this.createClient.name = this.createClientForm.value.name;


   
    this.apiService.putUpdate('client-frente-update', this.createClient)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title:'Se ha editado correctamente',text: '',icon: 'success',heightAuto: false})
            .then(() => {
              this.router.navigate(['/pdg/client/frente/'+this.id_client])
            });
          //  this.router.navigate(['/pdg/project/pay/list', this.idProject, this.title]);
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}
